"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.default = (function (virtual) { return function (data) {
    var raw = utils_1.splitByLength(data.raw || '');
    var frame = [
        0x48,
        5 + Math.floor(raw.length / 2),
        1,
        (data.msgId || 0) % 0x100
    ].map(function (val) { return utils_1.decToHex(val); });
    frame.push.apply(frame, raw);
    // 获得校验位数值
    var checkCode = frame.reduce(function (val, b) { return val + utils_1.hexToDec(b); }, 0);
    frame.push(utils_1.decToHex(checkCode).slice(-2));
    return {
        raw: frame.join('')
    };
}; });



// WEBPACK FOOTER //
// ./src/encode/jsonTransparentNotCheckRaw.ts